export default __webpack_public_path__ + "static/media/Text_Format_Bold_ENG.c414f118.svg";